






















































































import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import Vue from 'vue';
import CtrlJigyosho from '@/components/common/search/CtrlJigyosho.vue';

export default Vue.extend({
  name: 'ListTokuisaki',
  components: {
    CtrlSearchCommonComponents,
    CtrlJigyosho,
    CtrlMessageDialog,
  },
  props: {
    jigyoshoCd: {
      type: Number,
    },
    seikyusakiKb: {
      type: Number,
    },
    targetYmd: {
      type: Number,
    },
    gyoshuCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
    jigyoshoHenkoFlg: {
      type: Boolean,
      default: false,
    },
    riyoshaTokuisakiTaishoFlg: {
      type: Number,
    },
  },
  data: () => ({
    tokuisakiCd: 0,
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'tokuisakiCd',
        width: 80,
      },
      {
        text: '名称',
        sortable: true,
        value: 'tokuisakiRyakuMei',
        width: 340,
      },
      {
        text: '本支店カナ',
        sortable: true,
        value: 'honShitenKana',
        align: " d-none"
      },
      {
        text: '請求先コード',
        sortable: true,
        value: 'seikyusakiCd',
        width: 130,
      },
      {
        text: '請求先名',
        sortable: true,
        value: 'seikyusakiMei',
        width: 340,
      },
    ],
    formatColName: 'tokuisakiCd',
    filterGroupKey: 0,
    jigyoshoCdRef: 0,
    jigyoshoMei: '',
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customSearch(value: any, search: string | null, item: any) {
      const filterValues = [
        item['tokuisakiCd'],
        item['tokuisakiRyakuMei'],
        item['honShitenKana'],
        item['seikyusakiCd'],
        item['seikyusakiMei'],
      ];

      return filterValues.some(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectJigyoshoItem(item: any) {
      this.jigyoshoCdRef = item.jigyoshoCd;
    },
    setupJigyoshoCd() {
      if (this.jigyoshoCd) {
        this.jigyoshoCdRef = this.jigyoshoCd;
      }
    },
    validateJigyosho(callbackGetData: any, callbackListClear: any) {
      if (!this.jigyoshoCdRef) {
        this.messageShow = true;
        this.messageId = 'KI_W100';
        this.messageTextParam = ['事業所'] as never;
        callbackListClear();
        return;
      } else {
        callbackGetData();
      }
    },
    resetData() {
      this.setupJigyoshoCd();
      // Increment to refresh form
      this.filterGroupKey += 1;
    },
    initialCheck() {
      if (
        this.$attrs.initialDataSearch &&
        (!this.jigyoshoCdRef || this.jigyoshoCdRef === 0)
      ) {
        this.messageShow = true;
        this.messageId = 'KI_W100';
        this.messageTextParam = ['事業所'] as never;
        return;
      }
    },
  },
  created() {
    this.setupJigyoshoCd();
  },
  mounted() {
    this.initialCheck();
  },
});
